<template lang="html">
  <div id="floorplan-detail" class="contained-height">
    <!-- Navigation -->
    <floorplan-detail-nav class=""
    :floorplan="floorplan" :navText="navText"/>

    <scrollable-content>
      <template>
        <!-- Details -->
        <floorplan-info :floorplan="floorplan.current" class="mt-2" />

        <!-- Units -->
        <floorplan-detail-units :floorplan="floorplan.current" class="mt-2" />

        <!-- Floor plan image -->
        <div class="fp-image py-3" :class="{'loaded': loaded}">
          <img :src="floorplanImgUrl" />
        </div>
      </template>
    </scrollable-content>
    <!-- Actionbar -->
    <floorplan-detail-actions class="bg-white"
    :floorplan="floorplan.current" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import ScrollableContentComponent from '@/components/ScrollableContent';
import FloorplanInfoComponent from '@/components/Floorplan/FloorplanInfo';
import fstore from '@/analytics/firestore';
import FloorplanDetailActionsComponent from './FloorplanDetailActions';
import FloorplanDetailNavComponent from './FloorplanDetailNav';
import FloorplanDetailUnitsComponent from './FloorplanDetailUnits';

export default {
  name: 'floorplan-detail',
  data() {
    return {
      floorplanImg: null,
      loaded: false,
      fpViewedTimeout: null
    };
  },
  computed: {
    ...mapState({
      assetsUrl: state => state.project.assetsUrl,
      showFavourites: state => state.floorplans.showFavourites,
      isTouchscreen: state => state.project.isTouchscreen
    }),
    ...mapGetters({
      getFloorplanById: 'floorplans/getFloorplanById',
      filteredFloorplanList: 'floorplans/filteredFloorplanList'
    }),
    navText() {
      const floorplanIndex = this.filteredFloorplanList
        .findIndex(floorplan => floorplan.id === this.$route.params.id) + 1;
      let navText =
        `viewing floorplan ${floorplanIndex} of ${this.filteredFloorplanList.length} filtered floorplans`;
      if (this.showFavourites) {
        navText =
        `viewing floorplan ${floorplanIndex} of ${this.filteredFloorplanList.length} favourited floorplans`;
      }
      return navText;
    },
    floorplan() {
      let fp = this.getFloorplanById(this.$route.params.id);
      if (!fp.current) {
        this.setShowFavourites(false);
        fp = this.getFloorplanById(this.$route.params.id);
      }
      return fp;
    },
    floorplanImgUrl() {
      return this.assetsUrl + this.floorplan.current.assets.floorplan.url;
    }
  },
  methods: {
    ...mapMutations({
      setShowFavourites: 'floorplans/setShowFavourites',
      setSelectedUnitName: 'floorplans/setSelectedUnitName'
    }),
    loadFloorplanImg() {
      this.floorplanImg = new Image();
      this.floorplanImg.onload = () => {
        setTimeout(() => {
          this.loaded = true;
        }, 250, this);
      };
      this.floorplanImg.src = this.assetsUrl + this.floorplan.current.assets.floorplan.url;
    },
    trackPlan() {
      if (!this.isTouchscreen) {
        const plan = this.floorplan.current;

        if (this.fpViewedTimeout) {
          clearTimeout(this.fpViewedTimeout);
        }

        this.fpViewedTimeout = setTimeout(() => {
          fstore.trackPlanView({
            name: plan.name,
            interior: plan.interior,
            beds: plan.beds,
            den: plan.dens > 0,
            baths: plan.baths,
            exposures: plan.exposure
          });
          this.fpViewedTimeout = null;
        }, 5000, this);
      }
    }
  },
  created() {
    this.loadFloorplanImg();
  },
  mounted() {
    this.trackPlan();
  },
  beforeRouteUpdate(to, from, next) {
    this.setSelectedUnitName('');
    next();
  },
  watch: {
    floorplan() {
      this.loadFloorplanImg();
      this.trackPlan();
    }
  },
  components: {
    'scrollable-content': ScrollableContentComponent,
    'floorplan-detail-actions': FloorplanDetailActionsComponent,
    'floorplan-detail-nav': FloorplanDetailNavComponent,
    'floorplan-info': FloorplanInfoComponent,
    'floorplan-detail-units': FloorplanDetailUnitsComponent
  },
  beforeDestroy() {
    // this.setSelectedUnitName('');
  }
};
</script>

<style lang="scss" scoped>
#floorplan-detail {
  position: relative;
  background-color: white;

  @media screen and (max-width: $breakpoint-sm) {
    // padding-top: $app-bar-height + 20;
  }

  .fp-image {
    opacity: 0;
    transition: opacity 0s ease-out;
    height: 70vh;

    &.loaded {
      min-height: initial;
      opacity: 1;
      transition: opacity 0.25s ease-out;
    }

    @media screen and (max-width: $breakpoint-xl) {
      height: 60vh;
    }

    @media screen and (max-width: $breakpoint-lg) {
      height: 50vh;
    }
  }

  .fp-image img {
    max-width: 100%;
    max-height: 60vh;
    width: 95%;
    height: 100%;
    object-fit: contain;

    @media screen and (max-width: $breakpoint-xl) {
      max-height: 60vh;
    }

    @media screen and (max-width: $breakpoint-lg) {
      max-height: 50vh;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplanDetail/FloorplanDetail.vue